<template>
  <div>
    <el-row class="navigator">
      <slot></slot>
    </el-row>
    <el-row>
      <transition name="fade" mode="out-in">
        <!-- <transition name="el-zoom-in-bottom"> -->
        <router-view
          @update="e=>$emit('update',e)"
          @delete="e=>$emit('delete',e)"
          @something-changed="reloadStaff"
        />
      </transition>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "sc-menu-navigator",
  props: {
    gutter: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {};
  },
  methods: {
    reloadStaff(e) {
      _log_("ooooorrrrrrrrrrrrrrr.", e);
      //classType: "ScheduleTrip", payload:
      this.$emit("update", e.payload);
    }
  }
};
</script>
<style lang="scss">
.navigator ul.el-menu {
  background-color: #095b69;

  .el-menu-item {
    color: aliceblue !important;
  }
}
</style>